/*******************************************************************************
  ConfirmModal.js

  Author: Advait
*******************************************************************************/

import React from "react";
import "../index.css";

function ConfirmModal({ isOpen, onClose, onConfirm, title, message }) {
  if (!isOpen) return null;

  return (
    <div className="addUserOverlay" onClick={onClose}>
      <div className="addUserContainer" onClick={(e) => e.stopPropagation()}>
        <button className="addUserCloseButton" onClick={onClose}>
          ×
        </button>
        <h3>{title}</h3>
        <p style={{ color: "white", marginBottom: "20px" }}>{message}</p>
        <div style={{ display: "flex", gap: "10px", justifyContent: "flex-end" }}>
          <button className="saveButton" onClick={onClose} style={{ minWidth: "100px" }}>
            Cancel
          </button>
          <button className="saveButton" onClick={onConfirm} style={{ minWidth: "100px" }}>
            Confirm
          </button>
        </div>
      </div>
    </div>
  );
}

export default ConfirmModal;
